export default function validateProjects(projectsList) {
  const errors = [];
  const warnings = [];
  const list = projectsList || [];
  
  const getSafeString = (val) => {
    if (!val) return "";
    if (Array.isArray(val)) return val.join("\n");
    return String(val);
  };

  if (list.length === 0) {
    warnings.push("Adding at least one project highlights hands-on skills.");
  } else {
    list.forEach((proj, idx) => {
      const titleVal = proj.name || proj.title;
      const titleStr = getSafeString(titleVal);
      const label = titleStr || `Project #${idx + 1}`;

      if (!titleStr || !titleStr.trim()) {
        errors.push(`[Project #${idx + 1}] Project name/title is missing.`);
      }
      
      const descVal = proj.description || (proj.points && proj.points[0]);
      const descStr = getSafeString(descVal);
      if (!descStr || !descStr.trim()) {
        warnings.push(`[${label}] Project details or description missing.`);
      }
    });
  }

  let percentage = 0;
  if (list.length > 0) {
    let score = 0;
    list.forEach(proj => {
      const titleVal = proj.name || proj.title;
      const titleStr = getSafeString(titleVal);
      if (titleStr.trim()) score += 50;

      const descVal = proj.description || (proj.points && proj.points[0]);
      const descStr = getSafeString(descVal);
      if (descStr.trim()) score += 50;
    });
    percentage = Math.round(score / list.length);
  }

  return {
    id: "projects",
    completed: errors.length === 0,
    percentage,
    errors,
    warnings
  };
}

